module.exports = __webpack_public_path__ + "02_veryshort_gold.f0377787.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/dad/layer5/02_veryshort_gold.png
// module id = 0m4Z
// module chunks = 0